<div
	class="flex w-full overflow-hidden mt-1 bg-gray-000 relative"
	data-cy="order-card-item"
	[attr.aria-label]="'سفارش ' + (order().symbolName ?? '')">
	@if (order().isExecuted) {
		<div class="w-1.5 shrink-0 self-stretch bg-blue-500" data-cy="order-card-executed-bar" aria-hidden="true"></div>
	}
	<div class="absolute inset-0 flex w-full justify-between">
		<div
			class="flex w-37.5 justify-end bg-gray-100 absolute top-px bottom-px"
			data-cy="order-card-swipe-right-actions"
			[class.right-1_5]="order().isExecuted">
			<button
				type="button"
				class="flex flex-1 flex-col items-center justify-center gap-0.5 text-gray-900"
				data-cy="order-card-copy-action"
				aria-label="کپی"
				(click)="onCopyClick()">
				<ui-icon [iconName]="'copy'" />
				<small class="text-3.25 text-gray-600">کپی</small>
			</button>
		</div>

		@if (!order().isExecuted) {
			<div
				class="flex w-37.5 justify-end bg-gray-100 absolute left-1.5 top-px bottom-px"
				data-cy="order-card-swipe-left-actions">
				<button
					type="button"
					class="flex flex-1 flex-col items-center justify-center gap-0.5 text-gray-900"
					data-cy="order-card-edit-action"
					aria-label="ویرایش"
					(click)="onEditClick()">
					<ui-icon [iconName]="'edit'" />
					<small class="text-3.25 text-gray-600">ویرایش</small>
				</button>
				<button
					type="button"
					class="flex flex-1 flex-col items-center justify-center gap-0.5 text-gray-900"
					data-cy="order-card-delete-action"
					aria-label="حذف"
					(click)="onDeleteClick()">
					<ui-icon [iconName]="'delete'" />
					<small class="text-3.25 text-gray-600">حذف</small>
				</button>
			</div>
		}
	</div>

	<div
		#swipeableCard
		appLongPress
		class="relative z-1 flex w-full min-w-0 bg-gray-000"
		[attr.swipeable]="selectionMode() ? null : ''"
		[id]="order().orderId"
		[attr.data-swipe-side]="order().isExecuted ? 'Left' : null"
		(pointerdown)="onCardPointerDown($event)"
		(shortClick)="onCardClick()"
		(longPress)="onLongPress()">
		@if (selectionMode()) {
			<div class="flex shrink-0 items-center" data-cy="order-card-checkbox" [class.ps-2]="isOrderOpen()">
				@if (isOrderOpen()) {
					<ui-checkbox
						structure="controlOnly"
						[ariaLabel]="'انتخاب سفارش'"
						[checked]="isChecked()"
						(valueChange)="checkboxChanged.emit(order().orderId)"
						(click)="$event.stopPropagation()"
						(touchstart)="$event.stopPropagation()"
						(touchend)="$event.stopPropagation()"
						(mousedown)="$event.stopPropagation()"
						(mouseup)="$event.stopPropagation()" />
				} @else {
					<div class="w-5"></div>
				}
			</div>
		}

		<div class="flex min-w-0 flex-1 flex-col gap-1 py-2 ps-3 pe-2">
			<div class="flex w-full items-center justify-between gap-1">
				<a
					#symbolLink
					class="min-w-0 truncate text-right text-base font-bold text-gray-900 cursor-pointer"
					[routerLink]="selectionMode() ? null : ['/symbol-details', order().symbolIsin]"
					(click)="selectionMode() ? null : $event.stopPropagation()">
					{{ order().symbolShortName }}
				</a>

				<div class="flex min-w-13 shrink-9999 items-center gap-1">
					<div class="flex min-w-0 items-center gap-1" data-cy="order-card-status">
						@if (status().label; as statusLabel) {
							<small
								class="min-w-0 truncate text-3.25 font-medium text-gray-600"
								data-cy="order-card-status-label"
								>{{ statusLabel }}</small
							>
						}

						<ui-icon
							role="img"
							class="shrink-0"
							data-cy="order-card-status-icon"
							[attr.aria-label]="status().label ? null : status().ariaLabel"
							[attr.aria-hidden]="status().label ? true : null"
							[iconName]="status().icon"
							[class.text-blue-500]="status().tone === 'executed'"
							[class.text-red-500]="status().tone === 'expired'"
							[class.text-gray-900]="status().tone === 'sending'"
							[class.text-green-500]="status().tone === 'active'" />
					</div>

					<ui-chevron
						position="right"
						size="lg"
						class="shrink-0 border box-border inline-flex h-6 w-6 items-center justify-center rounded-lg border-gray-100"
						data-cy="order-card-detail-button" />
				</div>
			</div>

			<div class="flex w-full items-center justify-between text-3.25 font-medium text-gray-900">
				<ui-number data-cy="order-card-total-quantity" [value]="quantity()" />
				<span data-cy="order-card-execution-label">{{ executionLabel() }}</span>
			</div>

			<ui-progress-bar
				dir="ltr"
				size="small"
				data-cy="order-card-progress-bar"
				variant="blue"
				[value]="progressBarValue()" />

			<div class="flex w-full items-center justify-between">
				<ui-number
					format="1.0-0"
					data-cy="order-card-price"
					class="text-3.25 font-medium tabular-nums"
					[class.text-green-500]="order().side === OrderSide.Buy"
					[class.text-red-500]="order().side === OrderSide.Sell"
					[value]="price()" />

				<div class="flex items-center gap-0.5 text-3.25 font-medium text-gray-600">
					<span data-cy="order-card-date">{{ order().entryDate | jdate: 'time' | eDigit }}</span>
				</div>
			</div>
		</div>
	</div>
	<div
		data-cy="order-card-side-bar"
		class="w-1.5 shrink-0 self-stretch"
		[class.bg-green-500]="order().side === OrderSide.Buy"
		[class.bg-red-500]="order().side === OrderSide.Sell"
		[attr.aria-label]="order().side === OrderSide.Buy ? 'خرید' : 'فروش'"></div>
</div>
